import React from 'react';
import { i18n_breathwork } from '@yi/i18n/phrases/i18n_breathwork';

import { isPranayama } from '~/src/common/content';
import { encodeQueryString } from '~/src/common/utilities';
import { LocalizedLink } from '~/src/components/content-templates/MetaInfo';
import { MeditationsIcon, IconPranayama } from '~/src/components/icons';
import { useLocale } from '~/src/components/LocaleProvider';

import { Content } from '../types';

interface Props {
  content: Content;
}

const PranayamaTags: React.FC = () => {
  const { locale } = useLocale();

  return (
    <>
      <IconPranayama style={{ height: '24px', color: '#fff' }} />
      <div>
        <LocalizedLink to={`/pranayama/`}>{i18n_breathwork(locale)}</LocalizedLink>
      </div>
    </>
  );
};
export const MeditationTags: React.FC<Props> = ({ content }) => {
  const { style } = content;

  const styleName = style?.[0] ? style?.[0].name : '';
  const styleLink = styleName && (
    <LocalizedLink to={`/meditations/?style=${encodeQueryString(styleName)}`}>
      {styleName}
    </LocalizedLink>
  );

  return (
    <>
      <MeditationsIcon style={{ height: '24px', color: '#fff' }} />
      <div>{styleLink}</div>
    </>
  );
};

export const Tags: React.FC<Props> = ({ content }) => {
  return isPranayama(content) ? <PranayamaTags /> : <MeditationTags content={content} />;
};
